	
export default {
	data() {
		return {
		}
	},

	methods: {
		/*
		* The method call when need show seccuss alert for user
		*/
		showAlertSuccess(title, message) {
			iziToast.show({
				color: 'dark',
				icon: 'fa fa-envelope-open-o',
				title: title,
				message: message,
				position: 'topRight', 
				progressBarColor: '#777',

			});
		},

		showAlertError(title, message) {
			iziToast.error({title: title, message: message, position: 'topRight'});
			
		}




	},
	components: {
	}
}


// WEBPACK FOOTER //
// ./src/mixins/system/general.js